module.exports = __webpack_public_path__ + "img/section-3-content_3_about_personl.c042c20e.png";